module.exports = __webpack_public_path__ + "img/cloud-computing-lock.5d59367b.svg";